import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const Tenant = React.lazy(() =>
    import('../Tenant')
);
const tenantRoutesRegistry = [
    {
        path: PAGE_URL.TENANT_PAGE,
        element: <Tenant />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tenantRoutesRegistry;
